// Ensures a redirect target is an app-internal path, not an absolute URL or
// protocol-relative (`//host`) reference. Prevents CWE-601 open-redirect abuse
// when the path comes from a query string.
export function safeRedirect(candidate: string | undefined, fallback = '/'): string {
    if (!candidate || typeof candidate !== 'string') {
        return fallback;
    }
    if (!candidate.startsWith('/') || candidate.startsWith('//') || candidate.startsWith('/\\')) {
        return fallback;
    }
    return candidate;
}
